export const idlFactory = ({ IDL }) => {
  const Result = IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text });
  const DocumentStatus = IDL.Variant({
    'Active' : IDL.Null,
    'Draft' : IDL.Null,
    'Deprecated' : IDL.Null,
    'Archived' : IDL.Null,
  });
  const DocumentType = IDL.Variant({
    'ADR' : IDL.Null,
    'Error' : IDL.Null,
    'BestPractice' : IDL.Null,
    'Resolution' : IDL.Null,
  });
  const KBDocument = IDL.Record({
    'id' : IDL.Text,
    'status' : DocumentStatus,
    'component' : IDL.Text,
    'title' : IDL.Text,
    'updated_at' : IDL.Nat64,
    'content' : IDL.Text,
    'created_at' : IDL.Nat64,
    'related_docs' : IDL.Vec(IDL.Text),
    'version' : IDL.Nat32,
    'keywords' : IDL.Vec(IDL.Text),
    'summary' : IDL.Text,
    'severity' : IDL.Opt(IDL.Text),
    'doc_type' : DocumentType,
  });
  const DocumentResult = IDL.Variant({ 'Ok' : KBDocument, 'Err' : IDL.Text });
  const DocumentVersion = IDL.Record({
    'updated_at' : IDL.Nat64,
    'updated_by' : IDL.Opt(IDL.Principal),
    'content' : IDL.Text,
    'change_summary' : IDL.Text,
    'version' : IDL.Nat32,
  });
  const VersionHistory = IDL.Record({
    'document_id' : IDL.Text,
    'versions' : IDL.Vec(DocumentVersion),
  });
  const HistoryResult = IDL.Variant({
    'Ok' : VersionHistory,
    'Err' : IDL.Text,
  });
  const KBStatistics = IDL.Record({
    'resolutions' : IDL.Nat64,
    'total_documents' : IDL.Nat64,
    'adrs' : IDL.Nat64,
    'errors' : IDL.Nat64,
    'best_practices' : IDL.Nat64,
    'total_keywords' : IDL.Nat64,
  });
  const SearchRequest = IDL.Record({
    'component' : IDL.Opt(IDL.Text),
    'limit' : IDL.Opt(IDL.Nat32),
    'severity' : IDL.Opt(IDL.Text),
    'keyword' : IDL.Text,
    'doc_type' : IDL.Opt(DocumentType),
  });
  const StoreDocumentRequest = IDL.Record({
    'id' : IDL.Text,
    'component' : IDL.Text,
    'title' : IDL.Text,
    'content' : IDL.Text,
    'related_docs' : IDL.Vec(IDL.Text),
    'keywords' : IDL.Vec(IDL.Text),
    'summary' : IDL.Text,
    'severity' : IDL.Opt(IDL.Text),
    'doc_type' : DocumentType,
  });
  return IDL.Service({
    'clear_all_data' : IDL.Func([], [IDL.Text], []),
    'delete_document' : IDL.Func([IDL.Text], [Result], []),
    'export_all_documents' : IDL.Func([], [IDL.Vec(KBDocument)], ['query']),
    'get_document' : IDL.Func([IDL.Text], [DocumentResult], ['query']),
    'get_document_history' : IDL.Func([IDL.Text], [HistoryResult], ['query']),
    'get_statistics' : IDL.Func([], [KBStatistics], ['query']),
    'list_documents' : IDL.Func(
        [IDL.Opt(DocumentType)],
        [IDL.Vec(KBDocument)],
        ['query'],
      ),
    'search' : IDL.Func([SearchRequest], [IDL.Vec(KBDocument)], ['query']),
    'store_document' : IDL.Func([StoreDocumentRequest], [Result], []),
    'update_document' : IDL.Func(
        [IDL.Text, StoreDocumentRequest],
        [Result],
        [],
      ),
  });
};
export const init = ({ IDL }) => { return []; };
